import React from "react";
import { FluentBadge } from "../../../../../components/FluentUI/Fluent-Badge";
import "./priority-new.scss";
import PropTypes from "prop-types";

const PriorityNew = ({ priority }) => {
  return (
    <div className={`${priority} no-pointer width-fit-content`} >
      <FluentBadge
        shape="rounded"
        appearance="tint"
        size="extra-large"
        text={priority?.charAt(0)?.toUpperCase()}
      ></FluentBadge>
    </div>
  );
};

export default PriorityNew;

PriorityNew.propTypes = {
  priority: PropTypes.string.isRequired,
};
